import styled from 'styled-components';
import HotelIcon from '../../../../Icons/HotelIcon';
import CityIcon from '../../../../Icons/CityIcon';
import RightArrowNewIcon from '../../../../Icons/ArrowRightNew';
import {BaseColumnWrap} from '../../../CommonStyleUtils/dwebCommon.styles';

import HappyAngleRightIcon from '@stencil/icons/src/HappyAngleRightIcon/HappyAngleRightIcon';
import HappyHotelSearchIcon from '@stencil/icons/src/HappyHotelSearchIcon/HappyHotelSearchIcon';

export const RecentSearchOuterWrapper = styled.section(
  props => `
  max-width:120rem;
  width:100%;
  margin-top: ${props.theme.spacing.custom(50)};
  margin-bottom: ${props.theme.spacing.xxlarge};
  `,
);

export const SliderHeaderArrowWrapInner = styled.div(
  props => `
    width: 7.5rem;
    box-shadow: 0 0.1rem 0.4rem 0 ${props.theme.colors.shadow.light};
    background-color: ${props.theme.colors.goWhite.base};
    border-radius: ${props.theme.misc.borderRadius.custom(20)};
  `,
);

export const SliderArrowWrap = styled.a(
  props => `
    padding: ${props.theme.spacing.base};
    cursor: pointer;
    color: ${props.theme.colors.goBrandBlue.base};
    display: inline-flex;
    background:${props.theme.colors.goWhite.base};
    border-radius:50%;
    &:hover{
        color: ${props.theme.colors.goBrandBlue.base};
    }
  `,
);

export const RecentSearchSlider = styled.div(
  props => `
    overflow: hidden;
    padding-top: ${props.theme.spacing.large};
    padding-bottom: ${props.theme.spacing.small};
  `,
);

export const RecentSearchInnerWrapper = styled.ul(
  props => `
    list-style-type: none;
    display: flex;
    li{
      width: 28.5rem;
      background-color: ${props.theme.colors.goWhite.base};
      padding: ${props.theme.spacing.large};
      border-radius: ${props.theme.misc.borderRadius.large};
      box-shadow: 0 0.1rem 0.4rem 0 ${props.theme.colors.shadow.base};
      margin-right: ${props.theme.spacing.xlarge};
      height: 10.5rem;

      &:last-child{
          margin-right:0;
      }
    }
  `,
);

export const RecentSearchInfoWrapper = styled(BaseColumnWrap)`
  cursor: pointer;
`;

export const RecentSearchHotelText = styled.p(
  props => `
    max-width: 22rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: capitalize;
    font-size: ${props.theme.font.custom(16)};
    color: ${props.theme.colors.goBrandBlue.base};
    font-family: ${props.theme.font.fontFamily};
    font-weight: bold;
    background: ${props.theme.colors.goBrandBlue.medium};
    border-radius: ${props.theme.misc.borderRadius.custom(13)};
    padding: ${props.theme.spacing.custom(2)} ${props.theme.spacing.base};
    `,
);

export const RecentSearchDateText = styled.span(
  props => `     
    font-size: ${props.theme.font.custom(16)};
    padding-top: ${props.theme.spacing.custom(8)};
    padding-bottom: ${props.theme.spacing.small};
  `,
);

export const RecentSearchPaxText = styled.span(
  props => `
    color: ${props.theme.colors.downriver.medium};
    font-size: ${props.theme.font.custom(14)};
  `,
);

export const HotelIconWrap = styled(HappyHotelSearchIcon)(
  props => `

  width:1.8rem;
  height:1.8rem;
  fill:${props.theme.colors.goBrandBlue.base};
  margin-right: ${props.theme.spacing.small};
  position:relative;
  top: .2rem;
`,
);

export const CityIconWrap = styled(HotelIconWrap)(
  props => `
  width:1.8rem;
  height:1.8rem;
  fill:${props.theme.colors.goBrandBlue.base};
  margin-right: ${props.theme.spacing.small};
  position:relative;
  top: .2rem;
`,
);

export const RightArrowNewIconWrap = styled(HappyAngleRightIcon)(
  props => `
  width:1.2rem;
  height:1.2rem;
  fill:${props.theme.colors.goBrandBlue.base};
`,
);
